export default "__VITE_ASSET__BhTIBK5H__"